import React, { useState, useEffect } from 'react';
import './BusinessInfoForm.css'; // Agrega estilos si lo necesitas
import { Helmet } from 'react-helmet';
import { BriefcaseIcon, EnvelopeIcon, PhoneIcon, GlobeAltIcon } from '@heroicons/react/24/outline';
const BusinessInfoForm = () => {
    const [formData, setFormData] = useState({
        businessName: '',
        businessType: '',
        hasDomain: '', // Pregunta sobre dominio
        cardInformation: [],
        additionalInfo: '',
        clientId: '', // Añadimos el campo clientId para guardarlo
      });
      

  const [formValid, setFormValid] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    validateForm();
  }, [formData]);

  // Validar el formulario
  const validateForm = () => {
    const isFormValid =
      formData.businessName &&
      formData.businessType &&
      formData.hasDomain &&
      formData.cardInformation.length > 0;
    setFormValid(isFormValid);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      cardInformation: checked
        ? [...prevState.cardInformation, value]
        : prevState.cardInformation.filter((item) => item !== value),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!formValid) {
      setMessage('⚠️ Por favor, complete todos los campos antes de enviar.');
      return;
    }
  
    setSubmitting(true);
    setMessage('');
  
    // ✅ Añadir esta línea:
    const sessionId = sessionStorage.getItem('sessionId') || null;
  
    try {
      let leadCreated = false;
      let leadData = null;

      // 1️⃣ Registrar lead en Firestore
      const leadResp = await fetch(
        'https://registerlandinglead-xjpm53xzha-uc.a.run.app',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: formData.businessName,
            email: formData.email,
            phone: formData.phone,
            source: 'landing_page',
            sessionId,
            status: 'new',
            meta: {
              businessType: formData.businessType,
              hasDomain: formData.hasDomain,
              interests: formData.cardInformation,
              notes: formData.additionalInfo,
            },
          }),
        }
      );
    
      if (!leadResp.ok) {
        const t = await leadResp.text();
        throw new Error(`HTTP ${leadResp.status}: ${t}`);
      }
      leadData = await leadResp.json().catch(() => null);
      leadCreated = true;
    
      // 2️⃣ Enviar correo al administrador
      const adminResp = await fetch(
        'https://us-central1-tarjeta-ad945.cloudfunctions.net/sendBusinessInfo',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: formData.email,
            phone: formData.phone,
            businessName: formData.businessName,
            businessType: formData.businessType,
            hasDomain: formData.hasDomain,
            cardInformation: formData.cardInformation,
            additionalInfo: formData.additionalInfo,
          }),
        }
      );
    
      if (!adminResp.ok) {
        const t = await adminResp.text();
        console.warn('⚠️ Error al enviar correo admin:', t);
        throw new Error(`Falló el correo admin: ${adminResp.status}`);
      }
    
    
  
      // 🔹 3️⃣ Disparar evento de conversión de Google Ads / Analytics
      if (leadCreated && typeof window.gtag !== 'undefined') {
        window.gtag('event', 'conversion', {
          send_to: 'AW-16987830296/zaL6CJTh4pYYENz3rJUp',
          value: 1,
          currency: 'USD',
          event_label: `Landing Conversion ${leadData?.leadId || ''}`.trim(),
        });
      }

      // 🔹 3️⃣b Disparar evento Lead de Meta Pixel
      if (leadCreated && typeof window.fbq !== 'undefined') {
        window.fbq('track', 'Lead', {
          content_name: formData.businessType || 'BookMe Business Info Form',
          content_category: 'lead_form',
        });
      }
  
      // 🔹 4️⃣ Confirmación visual
      setMessage('✅ ¡Gracias! Su información fue enviada correctamente.');
      setFormData({
        businessName: '',
        businessType: '',
        hasDomain: '',
        cardInformation: [],
        additionalInfo: '',
        email: '',
        phone: '',
      });
  
    } catch (error) {
      console.error('❌ Error en el envío del formulario:', error);
      setMessage('❌ Ocurrió un error al procesar su solicitud. Inténtalo nuevamente.');
    }
  
    setSubmitting(false);
  };
  

  return (
    <div className="relative bg-white p-8 rounded-2xl shadow-xl max-w-3xl mx-auto">
      <Helmet>
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16987830296"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-16987830296');
          `}
        </script>
      </Helmet>

      {/* SVG decorativo superior */}
      <svg
        className="absolute top-0 left-0 w-full h-20 text-orange-100"
        preserveAspectRatio="none"
        viewBox="0 0 1440 320"
      >
        <path
          fill="currentColor"
          d="M0,160L80,149.3C160,139,320,117,480,122.7C640,128,800,160,960,154.7C1120,149,1280,107,1360,85.3L1440,64V0H1360C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0H0Z"
        />
      </svg>

      <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
        <BriefcaseIcon className="w-6 h-6 text-orange-500" />
        Cuéntanos sobre tu negocio
      </h2>

      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Nombre */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nombre del Negocio o Persona:
          </label>
          <input
            type="text"
            name="businessName"
            value={formData.businessName}
            onChange={handleInputChange}
            required
            className="w-full p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Correo Electrónico:
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
            className="w-full p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
        </div>

        {/* Teléfono */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Teléfono:
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
            className="w-full p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
        </div>

        {/* Tipo de negocio */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Tipo de Negocio:
          </label>
          <select
            name="businessType"
            value={formData.businessType}
            onChange={handleInputChange}
            required
            className="w-full p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            <option value="">Selecciona una opción</option>
            <option value="Spa / Clínica Estética">Spa / Clínica Estética</option>
            <option value="Restauración / Seguros">Restauración / Seguros</option>
            <option value="Restaurantes">Restaurantes</option>
            <option value="Estilista">Estilista</option>
            <option value="Contratista">Contratista</option>
            <option value="Bienes Raíces">Bienes Raíces</option>
            <option value="Artista">Artista</option>
            <option value="Entretenimiento">Entretenimiento</option>
            <option value="Abogado">Abogado</option>
            <option value="Doctor">Doctor</option>
            <option value="Otros">Otros</option>
          </select>
        </div>

        {/* Dominio */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            ¿Ya tiene un dominio para su negocio?
          </label>
          <select
            name="hasDomain"
            value={formData.hasDomain}
            onChange={handleInputChange}
            required
            className="w-full p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            <option value="">Selecciona una opción</option>
            <option value="Sí">Sí</option>
            <option value="No">No</option>
          </select>
        </div>

        {/* Info que necesita */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            ¿Qué necesitas en tu sistema o tarjeta digital?
          </label>
          <div className="grid grid-cols-2 gap-2">
            {['Calendario', 'Citas', 'WhatsApp BOT', 'Redes Sociales', 'Website', 'Otros'].map((item) => (
              <label key={item} className="text-sm text-gray-600 flex items-center gap-2">
                <input
                  type="checkbox"
                  value={item}
                  onChange={handleCheckboxChange}
                  checked={formData.cardInformation.includes(item)}
                />
                {item}
              </label>
            ))}
          </div>
        </div>

        {/* Comentarios */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            ¿Qué otras acciones necesitas en tu sistema?
          </label>
          <textarea
            name="additionalInfo"
            value={formData.additionalInfo}
            onChange={handleInputChange}
            rows={4}
            className="w-full p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
        </div>

        {/* Submit */}
        <div className="pt-4">
          <button
            type="submit"
            className="w-full py-3 bg-orange-500 text-white font-bold rounded-xl hover:bg-orange-600 transition shadow-lg"
            disabled={!formValid || submitting}
          >
            {submitting ? 'Enviando...' : 'Enviar Información'}
          </button>
        </div>

        {/* Mensaje */}
        {message && (
          <p className="mt-4 text-center text-sm font-medium text-green-600">
            {message}
          </p>
        )}
      </form>
    </div>
  );
};

export default BusinessInfoForm;
